import { GetServerSideProps, GetServerSidePropsContext, NextPageContext } from 'next';
import { getStaticContent } from '@/actions/ecom/staticContent';
import PageLayout from '@/components/Layouts/PageLayout';
import useLayoutRenderer from '@/hooks/useLayoutRenderer';
import SharedStaticContent from '@/components/Static/Shared/SharedStaticContent';

import { FC, MemoExoticComponent } from 'react';
import StaticImageBanner from '@/components/Static/Shared/StaticImageBanner';
import Heading from '@/shared/Heading';
import Div from '@/shared/Div';
import Container from '@/shared/Container';
import getSingleString from '@/utils/string';
import { CMS_COMPONENTS } from '@/constants/cms';
import DynamicPlaceholder from '@/shared/crisp/DynamicPlaceholder';
interface PageProps {
  page: {
    layout: any;
    seo: any;
    title: any;
  };
}

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext,
) => {
  const { query } = context;
  const { slug } = query;
  let url = '';
  if (slug && Array.isArray(slug)) {
    url = '/' + slug?.join('/');
  } else {
    url = getSingleString(slug);
  }

  try {
    const page = await getStaticContent(url);
    return {
      props: {
        page,
      },
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
};

const STATIC_MAP: { [key: string]: MemoExoticComponent<any> | FC<any> } = {
  [CMS_COMPONENTS.SHARED.HTML]: SharedStaticContent,
  [CMS_COMPONENTS.STATIC.IMAGE_BANNER]: StaticImageBanner,
  [CMS_COMPONENTS.SHARED.DYNAMIC_PLACEHOLDER]: DynamicPlaceholder,
};

const PaymentSuccessPage: FC<PageProps> = ({ page }) => {
  const { layout, title } = page;
  const renderLayout = useLayoutRenderer(layout, STATIC_MAP);
  return (
    <PageLayout seo={page?.seo} pageWrapperClassName="font-primary ">
      <Div className="static-page-container font-primary">
        {title ? (
          <Container>
            <Heading level={1} className="mt-s4 mb-s4">
              {title}
            </Heading>
          </Container>
        ) : null}
        {renderLayout}
      </Div>
    </PageLayout>
  );
};

export default PaymentSuccessPage;
